<template>
  <div class="batchButton">
    <pendant titleName="请填写游客信息"></pendant>
    <div class="button-box">
      <button @click="clickBatch" class="batch">批量导入</button>
      <!-- <router-link class="batch" to="/touristBatchImport">批量导入</router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "batchButton",
  methods: {
    clickBatch(){
      this.$emit('clickBatch');
    }
  }
};
</script>

<style scoped lang='less'>
.batchButton{
  margin-top: 0.4rem;
  padding: 0.4rem;
  background: #FFFFFF;
  border-radius: .213333rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .button-box{
    display: flex;
    justify-content: flex-end;
    .batch{
      width: 2.12rem;
      height: .706667rem;
      font-size: .4rem;
      color: #9D6C29;
      line-height: .706667rem;
      border-radius: .466667rem;
      border: 1px solid #9D6C29;
      text-align: center;
    }
  }
}
</style>
